<script lang="ts">
	import DecoratedHeadline from "./DecoratedHeadline.svelte";
	import type { Product } from "../../../core/schema/Product.js";
	import ProductCard from "./ProductCard.svelte";
	import type { Category } from "../../../core/schema/Category.js";
	import { nbspify } from "../../../core/utils/nbspify.js";

	export let title = "Další z kategorie";
	export let products: Product[];
	export let categories: Category[];
</script>

<div class="flex w-full flex-col items-center sm:px-4 md:px-10">
	<div class="flex flex-col gap-8">
		<DecoratedHeadline>{nbspify(title)}</DecoratedHeadline>
		<slot name="perex" />
	</div>

	<div class="mt-16 flex w-full flex-wrap items-start justify-center gap-5 gap-y-16 md:px-6 lg:px-10 xl:px-16">
		{#each products as product}
			{@const category = categories.find((item) => product.categoryId === item.id)}
			{#if category}
				<ProductCard {product} {category} />
			{/if}
		{/each}
	</div>
</div>
